export default __webpack_public_path__ + "static/media/n_wdt_c_0.24d99f61.mp3";